import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { deleteToken, getAccessToken } from '../../utils/cookieHandler';

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  // fetching access token here
  const accessToken = getAccessToken();

  const navigate = useNavigate();

  // redirecting user to login page if access token doesn't exists here
  useEffect(() => {
    if (accessToken === null) {
      toast.error('Token Expired!! Please, Login Again!!', {
        toastId: 'token-expired-effect',
      });

      deleteToken();

      sessionStorage.clear();
      localStorage.clear();

      navigate('/', { replace: true });
    }
  }, [accessToken, navigate]);

  // rendering protected routes here based on access token
  return <>{children}</>;
};

export default ProtectedRoute;
